// Nav guard for Premium data mode (D-152). If Premium is selected but no data
// connection is established, moving to another bottom tab is blocked by a dialog
// that offers to establish a connection or revert to Free. Free is always allowed.

import { el } from "./dom.js";
import { setDataMode, modeSatisfied } from "./data-mode.js";

/**
 * Returns true if navigation may proceed. If it can't (Premium + no connection),
 * shows the blocking dialog and returns false. `openConnections` is how this
 * surface opens the Connections UI (web route vs extension tab).
 */
export async function canLeaveForNav(openConnections: () => void): Promise<boolean> {
  if (await modeSatisfied()) return true;
  showGate(openConnections);
  return false;
}

function showGate(openConnections: () => void): void {
  if (document.getElementById("ta-mode-gate")) return;
  const overlay = el("div", {
    attrs: { id: "ta-mode-gate" },
    style: { position: "fixed", inset: "0", zIndex: "10000", background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", padding: "18px" },
  });
  const close = (): void => overlay.remove();
  const card = el("div", {
    style: { maxWidth: "320px", width: "100%", background: "var(--bg-elevated)", border: "1px solid var(--border)", borderRadius: "16px", padding: "20px", textAlign: "center", display: "flex", flexDirection: "column", gap: "12px" },
  }, [
    el("div", { text: "Establish a connection", style: { font: "var(--font-header)" } }),
    el("div", {
      text: "You're in Premium mode but haven't connected a data feed yet. Connect one to build with your own data, or switch back to Free (Yahoo stocks).",
      style: { font: "var(--font-caption)", color: "var(--text-secondary)" },
    }),
    el("button", { className: "pill", text: "Establish a connection", style: { background: "var(--accent-blue)", color: "#fff", border: "0" }, onClick: () => { close(); openConnections(); } }),
    el("button", { className: "pill", text: "Revert to Free", onClick: () => { void setDataMode("free"); close(); } }),
  ]);
  // Click the backdrop = dismiss (stays on the current tab, still in Premium).
  overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
  overlay.appendChild(card);
  document.body.appendChild(overlay);
}
